import React from 'react';
import Topbar from './Topbar'; 

const Layout = ({ children, onLogout}) => {
  return (
    <div>
      <Topbar onLogout={onLogout}/>
      <div className="content-container">
        {children}
      </div>
    </div>
  );
};

export default Layout;
